const equipmentList = {
  "v-card-title": "Assets",
  plantList: "Areas",
  area: "Area",
  "span-statitics": "Graphs",
  "span-inspections-list": "Check Asset Inspections",
  "span-repair-list": "Check Repair Log",
  "span-new-repair-logs": "New Repair Report",
  "belongs-to": "Belongs To",
  customer: "Company",
  equipImg: "Asset Image",
  equipTag: "Asset Tag",
  status: "Reliability Status",
  equipType: "Asset Type",
  inspections: "New Inspection",
  "label-search": "Search",
  operations: "Status from Operations",
  plant: "Facility",
  profile: "Profile",
  pilot: "HOUSTON",
  cancel: "Cancel",
  reliability: "New Reliability Report",
  "repair-logs": "New Reparation",
  unit: "Unit",
  scanAndInspect: "Scan And Inspect",
  reportError: "Tech Support",
  scanQR: "Scan QR",
  zones: {
    zone: "Zone",
    smooth: "Smooth",
    warning: "Warning",
    alarm: "Alarm"
  },
  running: "Running"
};

export default equipmentList;
